import api from "./api";
import i18n from "../i18n";
import { toast } from "sonner";

export async function downloadCapturesPdf(captureIds) {
  try {
    const response = await api.post("/captures/export-pdf", { capture_ids: captureIds }, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = "captures.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    toast.success(i18n.t("toast.pdfDownloadedSuccess"));
  } catch (e) {
    toast.error(i18n.t("toast.pdfDownloadFailedError"));
  }
}
